module.exports = __webpack_public_path__ + "static/img/LHL.dd3e871c.png";